const FiltersEnum = Object.freeze({
  Čeština: 'Filtry',
  Deutsch: 'Filter',
  Français: 'Filtres',
  Slovenčina: 'Filtre',
  Español: 'Filtros',
  English: 'Filters',
})

export default FiltersEnum
